import Tween from "tween.ts";
import Animation from "../../../../../../src/animation/Animation";
import RedPoint from "../../../../../../src/entities/RedPoint";


export default class PointAnimation extends Animation {
  constructor(Point: RedPoint, visible: boolean, onComp: () => void) {
    super();
    const tS = visible ? 1 : .3;
    visible ? Point.visible = true : "";
    new Tween.Tween(Point.scale)
      .to({ x: tS, y: tS }, 300)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => {
        Point.visible = visible;
        onComp()
      })
      .start()
  }
}